import { LEADS_SET_IS_ASSIGNED_TAB } from '../constants'

export function reducer(state, action) {
    if (action.type === LEADS_SET_IS_ASSIGNED_TAB) {
        return{
            ...state,
            isAssignedTab: action.value
        }
    } else {
        return state; 
    }      
}
